import { Button, Flex, Stack, Td, Tr, useDisclosure } from "@chakra-ui/react";
import AcceptModal from "./AcceptModal";
import DeleteModal from "./DeleteModal";
import { convertISOToLocalDate } from "../../../../utils/date.utils";

function RequestsListItem(props) {
  const { request } = props;
  const { userId, createdAt, status } = request;

  const {
    isOpen: onAcceptModal,
    onOpen: onOpenAcceptModal,
    onClose: onCloseAcceptModal,
  } = useDisclosure();
  const {
    isOpen: onDeleteModal,
    onOpen: onOpenDeleteModal,
    onClose: onCloseDeleteModal,
  } = useDisclosure();

  return (
    <>
      <Tr py="14px" key={request._id}>
        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {userId.name}
        </Td>
        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {convertISOToLocalDate(createdAt)}
        </Td>

        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          <Flex gap="10px" justifyItems={"center"} justifyContent={"center"}>
            {status === "PENDING" && (
              <Stack direction="row">
                <Button
                  bg="transparent"
                  background="#27AC2D"
                  color="white"
                  fontSize="14px"
                  onClick={onOpenAcceptModal}
                  fontWeight="500"
                  _hover={{ background: "#E3F4E4", color: "#27AC2D" }}
                  borderRadius="6px"
                >
                  Accept
                </Button>
                <Button
                  bg="transparent"
                  background="#FF6A52"
                  color="white"
                  fontSize="14px"
                  onClick={onOpenDeleteModal}
                  fontWeight="500"
                  _hover={{ background: "#FCE9E8", color: "#FF6A52" }}
                  borderRadius="6px"
                >
                  Decline
                </Button>
              </Stack>
            )}

            {status === "APPROVED" && (
              <Stack direction="row">
                <Button
                  bg="transparent"
                  background="#E3F4E4"
                  color="#27AC2D"
                  fontSize="14px"
                  fontWeight="500"
                  borderRadius="6px"
                >
                  Approved
                </Button>
              </Stack>
            )}

            {status === "REJECTED" && (
              <Stack direction="row">
                <Button
                  bg="transparent"
                  background="#FCE9E8"
                  color="#FF6A52"
                  fontSize="14px"
                  fontWeight="500"
                  borderRadius="6px"
                >
                  Rejected
                </Button>
              </Stack>
            )}
          </Flex>
        </Td>
      </Tr>
      {onAcceptModal && (
        <AcceptModal request={request} onClose={onCloseAcceptModal} />
      )}
      {onDeleteModal && (
        <DeleteModal request={request} onClose={onCloseDeleteModal} />
      )}
    </>
  );
}

export default RequestsListItem;
